import { FC } from 'react';

import './styles.scss';
import { Button, Container, FullWidth } from 'components';
import { ButtonProps } from 'components/Button/types';
import logo from 'images/logo.svg';

interface SunsetMessageProps {
	title: string;
	tagline: string;
	paragraph: string | string[];
	button: ButtonProps;
}

const SunsetMessage: FC<SunsetMessageProps> = ({
	title,
	tagline,
	paragraph,
	button,
}) => {
	const paragraphs = Array.isArray(paragraph) ? paragraph : [paragraph];

	return (
		<FullWidth className="sunset-message">
			<Container>
				<div className="inner">
					<img className="logo" src={logo} alt="Department of Web" />
					<h1 className="title">{title}</h1>
					<p className="tagline">{tagline}</p>
					{paragraphs.map((text, i) => (
						<p key={i} className="paragraph">
							{text}
						</p>
					))}
					<div className="cta">
						<Button {...button} />
					</div>
				</div>
			</Container>
		</FullWidth>
	);
};

export default SunsetMessage;
